export default __webpack_public_path__ + "static/media/background-view-mobile.9883a453.png";